import Marquee from "react-fast-marquee";
import { CLIENTS } from "@/constants/testIds";

const clients = [
  { url: "/assets/client_logo/xhsojidb_undp_new.png", alt: "UNDP", portrait: true },
  { url: "/assets/client_logo/m1g6tx72_kemensekneg_trans_bg.png", alt: "Kementrian Sekretariat Negara" },
  { url: "/assets/client_logo/juijgwbd_jakpro.png", alt: "JAKPRO" },
  { url: "/assets/client_logo/ygpfkvsx_migas_trans_bg.png", alt: "ESDM · Migas" },
  { url: "/assets/client_logo/w44jag99_jnto_trans_bg.png", alt: "JNTO" },
  { url: "/assets/client_logo/9du3z9ii_logo_binus.png", alt: "Binus University" },
  { url: "/assets/client_logo/egox0075_fomo_trans_bg.png", alt: "FOMO" },
  { url: "/assets/client_logo/a4vlj7vk_ranting.png", alt: "Ranting Ranting" },
  { url: "/assets/client_logo/ad3d7nha_larusso_trans_bg_wte.png", alt: "LARUSSO" },
  { url: "/assets/client_logo/iey05vvq_kloa_trans_bg.png", alt: "KLOA" },
  { url: "/assets/client_logo/cumpnldg_tyo_original_bg.png", alt: "TYO" },
  { url: "/assets/client_logo/gonn1uag_mc_deli_trans_bg.png", alt: "MCdeli" },
  { url: "/assets/client_logo/j9urlejp_thailand.png", alt: "Amazing Thailand" },
  { url: "/assets/client_logo/8vrrclhq_myway_trans_bg.png", alt: "MyWay" },
];

export default function Clients() {
  return (
    <section
      data-testid={CLIENTS.section}
      className="relative py-16 border-t border-cyan-900/40 bg-[#070707]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="overline">/ trusted_by.roster</div>
            <h3 className="mt-3 font-mono-display text-xl md:text-2xl uppercase tracking-tight text-slate-100">
              A range of partners we&apos;ve shipped for
            </h3>
          </div>
          <span className="font-hud text-cyan-400/70">{clients.length} allies · sync active</span>
        </div>
      </div>

      <div className="marquee-mask">
        <Marquee gradient={false} speed={35} pauseOnHover={true}>
          {clients.map((c) => (
            <div key={c.alt} className="mx-10 flex items-center h-32">
              <img
                src={c.url}
                alt={c.alt}
                className={`client-logo w-auto ${
                  c.portrait ? "max-h-32" : "max-h-20 md:max-h-24"
                } ${c.killWhiteBg ? "kill-white-bg" : ""}`}
                loading="lazy"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
